import React from 'react'
import BlockVideo from '@berlitz/blocks/lib/BlockVideo'
import { getBackgroundColor } from '../../functions/utils'
import { SliceWrapper } from '../SliceWrapper'

const SliceVideo = ({ primary, backgroundColor }) => {
  return (
    <SliceWrapper backgroundColor={getBackgroundColor(primary.section_background_color)}>
      <BlockVideo
        backgroundColor={getBackgroundColor(primary.section_background_color)}
        youtubeVideoId={primary.youtube_video_id}
      />
    </SliceWrapper>
  )
}

export default SliceVideo
